module.exports = __webpack_public_path__ + "static/hero-c9c83a66f88b0f90f5f1589c0e74ca37.jpg";